<template>
  <v-card class="text-xs-center">
        <v-dialog v-model="dialog" max-width="500" persistent>
            <v-card class="text-xs-center">
                <v-card-title class="subheading justify-center">You have already suscbribed!</v-card-title>
                <v-btn color="purple" dark @click="$router.go(-1)">go to profile</v-btn>
            </v-card>
        </v-dialog>
        <!-- <v-dialog v-model="errorDialog" max-width="350">
            <v-card>
                <v-card-title>{{errorMsg}}</v-card-title>
            </v-card>
        </v-dialog> -->
    </v-card>
</template>

<script>
export default {
  name: "stripe",

  data: () => ({
      dialog: true,
  }),

  created() {
      this.$router.push('/profile/' + this.$route.params.status)
  }
};
</script>

<style lang="scss" scoped>
</style>
